import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Message, MessageSections } from '../pages/components/message/message';
import { MessageLoader } from '../router/blocks/route-components/message.loader';
import Calculate from '../pages/calculate';
import { DialogWrapper } from '../pages/home/components/ShippingPrices/styled.components';

interface CalculatorModalContextType {
  isOpen: boolean;
  openCalculator: () => void;
  closeCalculator: () => void;
}

const CalculatorModalContext = createContext<CalculatorModalContextType | undefined>(undefined);

export const useCalculatorModal = () => {
  const context = useContext(CalculatorModalContext);
  if (!context) {
    throw new Error('useCalculatorModal must be used within a CalculatorModalProvider');
  }
  return context;
};

interface CalculatorModalProviderProps {
  children: ReactNode;
}

export const CalculatorModalProvider: React.FC<CalculatorModalProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openCalculator = () => setIsOpen(true);
  const closeCalculator = () => setIsOpen(false);

  return (
    <CalculatorModalContext.Provider value={{ isOpen, openCalculator, closeCalculator }}>
      {children}
      {isOpen && (
        <MessageLoader key={MessageSections.CALCULATE} sectionName={MessageSections.CALCULATE}>
          <DialogWrapper 
            headerLabel={<Message messageKey={'calculation_title'} sectionId={MessageSections.CALCULATE} />} 
            onCancel={closeCalculator} 
            open={isOpen}
          >
            <Calculate inModal />
          </DialogWrapper>
        </MessageLoader>
      )}
    </CalculatorModalContext.Provider>
  );
};
